const rolesPath = {
  // unregistered: "/registers",
  unregistered: "/sign-in",
  // super: "/admin",
  "Q9^B%^HWUc": "/admin",
  student: "/dashboard", 
  "6e5KXjhLJ": "/accountant",
};
export default rolesPath;
